<template>
	<div class="divide-y-2 divide-gray-200">
		<my-contracts-form-title v-if="creating" />

		<div
			class="p-6 grid grid-cols-2 sm:grid-cols-4 gap-y-6 gap-x-6 items-end"
			:class="creating ? 'pl-24' : ''"
		>
			<ui-select-group
				class="col-start-1 col-end-2"
				v-model="form.product.type"
				field="product.type"
				type="select"
				label="Article"
				:options="$cropOptions.productTypeOptions"
				:form="form"
				:required="true"
				v-on:change="productTypeChanged"
			></ui-select-group>

			<ui-select-group
				class="col-start-2 col-end-3"
				v-model="form.product.grade"
				field="product.grade"
				type="select"
				label="Quality Grade"
				:options="currentProductGradeOptions"
				:form="form"
				:required="true"
				:key="form.product.grade"
				v-if="hasMultipleGrades"
				v-on:change="productGradeChanged"
			></ui-select-group>

			<ui-select-group
				class="col-start-1 col-end-2"
				v-model="form.product.harvest"
				field="product.harvest"
				type="select"
				label="Harvest Year"
				:options="harvestYearOptions"
				:form="form"
				:required="true"
			>
			</ui-select-group>
		</div>

		<div
			class="p-6 grid grid-cols-2 sm:grid-cols-4 gap-y-6 gap-x-6 items-end"
			:class="creating ? 'pl-24' : ''"
		>
			<div
				:class="[
					'focus-within:text-orange-500',
					markContractDateInvalid ? 'text-red-500' : 'text-gray-700',
				]"
			>
				<div class="flex justify-start flex-wrap">
					<label class="block font-medium">Kontraktdatum</label>
					<ui-tooltip
						class="ml-2"
						:text="__('Datum, an dem Sie den Kontrakt abgeschlossen haben.')"
					/>
					<span class="text-red-500" v-if="markContractDateInvalid">
						{{ validationMessageContractDate }}
					</span>
				</div>
				<div class="mt-1 relative">
					<datepicker
						v-model="form.external_contract_date"
						@selected="setContractDate"
						:input-class="datePickerInputClass"
						format="dd.MM.yyyy"
					></datepicker>
				</div>
			</div>

			<ui-input-group
				v-model="form.buyer_name"
				field="buyer_name"
				label="Buyer"
				:form="form"
				:required="false"
			></ui-input-group>
		</div>

		<!--offer-edit-quality
			class="p-6 min-h-[8.25rem]"
			v-if="form.product.grade != null"
			ref="editQuality"
			:form="form"
		/>
		<div v-else class="p-6 min-h-[8.25rem] space-y-2">
			<p class="block font-medium text-gray-700">{{ __("Quality") }}</p>
			<p>{{ __("Please choose an article first!") }}</p>
		</div-->

		<div
			class="mt-6 grid gap-y-4 gap-x-6 grid-cols-2 md:grid-cols-4 p-6"
			:class="creating ? 'pl-24' : ''"
		>
			<ui-input-group
				v-model="form.qty.mt"
				field="qty.mt"
				label="Quantity in metric tons"
				suffix="t"
				:form="form"
				:required="true"
			></ui-input-group>
		</div>

		<div
			class="mt-6 grid gap-y-4 gap-x-6 grid-cols-2 md:grid-cols-4 p-6"
			:class="creating ? 'pl-24' : ''"
		>
			<ui-input-group
				v-model="form.price.mt"
				field="price.mt"
				label="Price"
				suffix="EUR/t"
				:form="form"
				:required="true"
				:dp="2"
			></ui-input-group>
		</div>
	</div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
function padTo2Digits(num) {
	return num.toString().padStart(2, "0");
}
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		creating: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		let contractDate = new Date(this.form.contract_date);
		this.form.external_contract_date = "";
		if (!this.creating) {
			this.form.external_contract_date =
				contractDate.getFullYear() +
				"/" +
				padTo2Digits(contractDate.getMonth() + 1) +
				"/" +
				padTo2Digits(contractDate.getDate());
		}
		return {
			selectedContractDate: this.form.external_contract_date,
		};
	},
	components: {
		Datepicker,
	},
	computed: {
		currentProductGradeOptions: function () {
			let currentProductType = this.form.product.type;
			return currentProductType
				? this.$cropOptions.productGradeOptions[currentProductType]
				: [];
		},
		hasMultipleGrades: function () {
			return (
				this.currentProductGradeOptions &&
				this.currentProductGradeOptions.length > 1
			);
		},
		harvestYearOptions: function () {
			return this.$cropOptions.harvestYearOptions.map(function (i) {
				return { id: i, name: i };
			});
		},
		markContractDateInvalid() {
			return this.form.hasErrors && this.form.errors["contract_date"] != null;
		},
		validationMessageContractDate() {
			return this.form.errors["contract_date"] || "";
		},
		datePickerInputClass() {
			return (
				"text-gray-900 shadow-sm focus:ring-orange-500 focus:border-orange-500 block w-full border-gray-300 rounded-md" +
				(this.markContractDateInvalid
					? " text-red-500 border-red-500 border-2 bg-red-100 shadow-sm focus:text-gray-900"
					: "")
			);
		},
	},
	methods: {
		productGradeChanged() {
			let that = this;
			//this.$nextTick(() => that.$refs.editQuality.qualityType = 'STANDARD')
			/*this.$nextTick(function () {
				that.$refs.editQuality.qualityType = "STANDARD";
				if (that.form.product.grade == "WHEAT_B__OTHER") {
					this.$nextTick(function () {
						that.$refs.editQuality.qualityType = "SPECIFIC";
					});
				}
			});
			console.log("PG CHANGED", this.qualityType);*/
		},
		productTypeChanged() {
			console.log(
				"product type changed",
				this.form,
				this.currentProductGradeOptions
			);
			if (!this.hasMultipleGrades) {
				this.form.product.grade = this.currentProductGradeOptions[0].id;
				this.productGradeChanged();
			}
		},
		setContractDate(selectedDate) {
			let date = new Date(selectedDate);
			this.selectedContractDate = date;
			let newDateStr =
				date.getFullYear() +
				"-" +
				padTo2Digits(date.getMonth() + 1) +
				"-" +
				padTo2Digits(date.getDate());
			console.log(newDateStr);
			this.form.contract_date = newDateStr;
		},
	},
	beforeDestroy() {},
	created() {},
	watch: {},
};
</script>
